import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _240ac2cd = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _1d63e17b = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _3298acec = () => interopDefault(import('../../../pages/builder-data-reports/index.vue' /* webpackChunkName: "pages/builder-data-reports/index" */))
const _b58da5be = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _4391d30c = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _21e70eba = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _3cda6383 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _a965f59a = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _7e23813a = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _3121f7a0 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _2a0b25b4 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _760203d6 = () => interopDefault(import('../../../pages/homeowner-dashboard/index.vue' /* webpackChunkName: "pages/homeowner-dashboard/index" */))
const _69db1888 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _64008be8 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _3ca4f903 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _1ee12b16 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _2e2f5b48 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _500452b2 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _3746e1ec = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _19b6b9b6 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _ca9ab79c = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _6306ee13 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _10aff8c0 = () => interopDefault(import('../../../pages/photo-booking-confirmation/index.vue' /* webpackChunkName: "pages/photo-booking-confirmation/index" */))
const _26635ea2 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _284fc4b4 = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _4edae0f6 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _813d28f8 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _5714c359 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _698900e4 = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _13a3583a = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _d87eff58 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _b2594ac6 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _106162fe = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _3d831ce2 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _4222ca78 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _a1e2fca2 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _087709a4 = () => interopDefault(import('../../../pages/admin/builder-report-management/index.vue' /* webpackChunkName: "pages/admin/builder-report-management/index" */))
const _4fe4e182 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _71764150 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _06f8c2ca = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _081ff062 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _c83b7cae = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _9c6aa4fa = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _48e8b620 = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _0762c9ea = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _76e430c0 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _4aace268 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _497925e8 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _686a277f = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _9593c0a8 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _7c412ced = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _1815a83c = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _6dcea39c = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _11878ef7 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _6dec31c5 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _b018a5c2 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _066d557a = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _29fe0654 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _944b3d28 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _1deb4af0 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _33ab40c2 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _f5927b52 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _6b1af1ec = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _355db81c = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _883e4a76 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _3ccaf7e4 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _569d25d8 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _dc8c23d4 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _9133cb1c = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _1ce951f3 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _c914b428 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _b7898c1a = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _3facea1c = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _770e07e2 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _5441cd5b = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _228b4fbd = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _943340a2 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _1dcd203e = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _3d18af69 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _240ac2cd,
    name: "404-error"
  }, {
    path: "/app",
    component: _1d63e17b,
    name: "app"
  }, {
    path: "/builder-data-reports",
    component: _3298acec,
    name: "builder-data-reports"
  }, {
    path: "/buy-sell-your-home",
    component: _b58da5be,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _4391d30c,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _21e70eba,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _3cda6383,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _a965f59a,
    name: "comparables"
  }, {
    path: "/contact",
    component: _7e23813a,
    name: "contact"
  }, {
    path: "/faq",
    component: _3121f7a0,
    name: "faq"
  }, {
    path: "/favourites",
    component: _2a0b25b4,
    name: "favourites"
  }, {
    path: "/homeowner-dashboard",
    component: _760203d6,
    name: "homeowner-dashboard"
  }, {
    path: "/list-home",
    component: _69db1888,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _64008be8,
    name: "listing-management"
  }, {
    path: "/login",
    component: _3ca4f903,
    name: "login"
  }, {
    path: "/market-data",
    component: _1ee12b16,
    name: "market-data"
  }, {
    path: "/messages",
    component: _2e2f5b48,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _500452b2,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _3746e1ec,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _19b6b9b6,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _ca9ab79c,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _6306ee13,
    name: "offers"
  }, {
    path: "/photo-booking-confirmation",
    component: _10aff8c0,
    name: "photo-booking-confirmation"
  }, {
    path: "/privacy",
    component: _26635ea2,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _284fc4b4,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _4edae0f6,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _813d28f8,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _5714c359,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _698900e4,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _13a3583a,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _d87eff58,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _b2594ac6,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _106162fe,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _3d831ce2,
    name: "users"
  }, {
    path: "/whoweare",
    component: _4222ca78,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _a1e2fca2,
    name: "why-bode"
  }, {
    path: "/admin/builder-report-management",
    component: _087709a4,
    name: "admin-builder-report-management"
  }, {
    path: "/admin/conversation",
    component: _4fe4e182,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _71764150,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _06f8c2ca,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _081ff062,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _c83b7cae,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _9c6aa4fa,
    name: "login-reset"
  }, {
    path: "/offers/submit-success",
    component: _48e8b620,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _0762c9ea,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _76e430c0,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _4aace268,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _497925e8,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _686a277f,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _9593c0a8,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _7c412ced,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _1815a83c,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _6dcea39c,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _11878ef7,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _6dec31c5,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _b018a5c2,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _066d557a,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _29fe0654,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _944b3d28,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _1deb4af0,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _33ab40c2,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _f5927b52,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _6b1af1ec,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _355db81c,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _883e4a76,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _3ccaf7e4,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _569d25d8,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _dc8c23d4,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _9133cb1c,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _1ce951f3,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _c914b428,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _b7898c1a,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _3facea1c,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _770e07e2,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _5441cd5b,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _228b4fbd,
    name: "listings-id-submit-success"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _943340a2,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _1dcd203e,
    name: "users-id-section"
  }, {
    path: "/",
    component: _3d18af69,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/user/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
